const Styles = {
    'ResultItem': 'ResultItem_ResultItem--86ac6cc1'
};

export default Styles;